var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-dropdown", {
    staticClass: "navUser-wrppaer"
  }, [_c("div", [_c("img", {
    staticClass: "userImg",
    attrs: {
      src: require("../../../assets/nav/user.gif"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "userTitle"
  }, [_vm._v(_vm._s(_vm.accountInfo.username || _vm.accountInfo.account))]), _c("a-icon", {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      type: "caret-down"
    }
  })], 1), _c("a-menu", {
    attrs: {
      slot: "overlay"
    },
    slot: "overlay"
  }, [_c("a-menu-divider"), _c("a-menu-item", [_c("span", {
    on: {
      click: function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.logout.apply(null, arguments);
      }
    }
  }, [_vm._v("退出登录 ")])])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };